import React from 'react';
import { partnerRoleDropdownFieldDef } from '../../data/data';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { UsersOfOrg } from './UsersOfOrg';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { StyleSheet } from 'aphrodite';

export class UsersOfOrgCustomPartner extends UsersOfOrg {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }

}


// WEBPACK FOOTER //
// ./src/common/components/UsersOfOrgCustomPartner.js